
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Instantly authenticate your investors' bank accounts for use with Apex Fintech Solutions Cash API"
};
export const partnerProps = {
  partner: 'Apex Fintech Solutions',
  clientLibrary: 'apex_clearing',
  subtitle: metadata.description,
  registrationUrl: 'https://go.apexclearing.com/request-dev-portal-access',
  apiUrl: 'https://apexfintechsolutions.com/developers/developer-portal/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Apex Fintech Solutions have partnered to offer frictionless linking of investors' bank accounts and their brokerage accounts. With this integration, Apex Fintech Solutions and Plaid clients will not ever need to handle bank account and routing numbers.`}</p>
    <p>{`With the Plaid + Apex Fintech Solutions integration, investors can onboard with ease by verifying their bank accounts in seconds using Plaid Link, a drop-in front-end module that handles input validation, error handling, and multi-factor authentication. Clients use Plaid Link to instantly authenticate your investor's account and generate a processor token, so Apex Fintech Solutions can then link the investor's account to their brokerage account. Investors can then immediately use the link to fund their brokerage account via ACH. This process provides a seamless brokerage account funding experience to investors.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthIdentityInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
